import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CarefindrAiComponent } from './carefindr-ai.component';
import { Grandmaster } from 'lo-bahamut';

@NgModule({
  declarations: [CarefindrAiComponent],
  imports: [CommonModule, FormsModule, Grandmaster],
  exports: [CarefindrAiComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CarefindrAiModule {}
